import { C } from '../../../lib/tokens.js';

// Used by ChatIntake's Business Partner + Contact fields - both need
// a manual reload since their options come from data that can change out-of-band
// (added via the WebUI in another tab) without the dropdown itself changing, and
// there's no other trigger that would make it refetch on its own.
export function RefreshableLabel({ label, onRefresh, title = 'Refresh list' }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      {label}
      <button type="button" onClick={onRefresh} title={title}
        style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0, display: 'flex', color: C.iron }}>
        <span className="material-icons" style={{ fontSize: 14 }}>refresh</span>
      </button>
    </span>
  );
}
